import { supabase } from '@/integrations/supabase/client';
import type { Json } from '@/integrations/supabase/types';

export type AuditActorRole = 'producer' | 'admin' | 'system';

export interface AuditEventParams {
  actorRole?: AuditActorRole;
  entityType: string;
  entityId?: string;
  action: string;
  message: string;
  metadata?: Record<string, unknown>;
}

/**
 * Log an audit event via the SECURITY DEFINER RPC.
 * Actor user ID is automatically resolved from auth context.
 *
 * @example
 * await logAuditEvent({
 *   entityType: 'producer',
 *   entityId: producerId,
 *   action: 'created',
 *   message: 'Producent skapad via onboarding',
 * });
 */
export async function logAuditEvent(params: AuditEventParams): Promise<string | null> {
  try {
    const { data: { user } } = await supabase.auth.getUser();

    const { data, error } = await supabase.rpc('log_audit_event', {
      p_actor_user_id: user?.id ?? null,
      p_actor_role: params.actorRole ?? 'producer',
      p_entity_type: params.entityType,
      p_entity_id: params.entityId ?? null,
      p_action: params.action,
      p_message: params.message,
      p_metadata: (params.metadata ?? {}) as Json,
    });

    if (error) {
      console.error('[logAuditEvent] Failed:', error);
      return null;
    }

    return data as string;
  } catch (err) {
    console.error('[logAuditEvent] Exception:', err);
    return null;
  }
}
